import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@wehunt/core-web'
import { useApiFetch } from '../../shared/api'
import { getTeamGameReportStats, type TeamGameReportStatsDto } from './api/gameReportStatsApi'

const gameReportStatsKey = (
  groupId: string | undefined,
  from: string | undefined,
  to: string | undefined,
) => ['clubhouse', 'groups', groupId, 'game-report-stats', from, to] as const

/**
 * Team game-report statistics over `[from, to]` (inclusive ISO-8601 instants).
 * The query is disabled until signed in and a full range is supplied, so a
 * period picker mid-edit never fires an incomplete request. Re-fetches whenever
 * the range changes (the range is part of the query key).
 */
export function useTeamGameReportStats(
  groupId: string | undefined,
  from: string | undefined,
  to: string | undefined,
) {
  const call = useApiFetch()
  const { state } = useAuth()
  const isSignedIn = state.status === 'signed-in'
  return useQuery({
    queryKey: gameReportStatsKey(groupId, from, to),
    enabled: isSignedIn && !!groupId && !!from && !!to,
    staleTime: 5 * 60 * 1000,
    queryFn: (): Promise<TeamGameReportStatsDto> =>
      getTeamGameReportStats(call, groupId ?? '', from ?? '', to ?? ''),
  })
}
